import axios from 'axios';
import Utils from 'utils';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://api.pushpulse.com'

axios.interceptors.response.use(undefined, (error) => {
  const errors = error?.response?.data;
  /*
  Handle errors like 404, 405, 403, and Networking issues
  */
  throw errors;
});

const responseData = (response) => response.data;
const requestHeaders = (protectedRoute, formData) => {
  let headers = {}
  headers['Accept'] = 'application/json';
  if (protectedRoute) {
    headers['Authorization'] = `Bearer ${Utils.getSessionToken()}`;
  }
  if (formData) {
    headers['Content-Type'] = 'multipart/form-data';
  }
  return {
    headers
  };
}
const http_requests = {
  get: (protectedRoute, url) => axios.get(url, requestHeaders(protectedRoute)).then(responseData),
  post: (protectedRoute, url, data) => axios.post(url, data, requestHeaders(protectedRoute)).then(responseData),
  delete: (protectedRoute, url) => axios.delete(url, requestHeaders(protectedRoute)).then(responseData),
  put: (protectedRoute, url, data) => axios.put(url, data, requestHeaders(protectedRoute)).then(responseData),
  postFormData: (protectedRoute, url, data) => axios.post(url, data, requestHeaders(protectedRoute, true))
  /*
  postFormData: (protectedRoute, url, file) => {
    var formData = new FormData();
    formData.append('file', file);
    return axios.post(url, formData, requestHeaders(protectedRoute, true))
  },
  postFormDataPrepared: (protectedRoute, url, object) => axios.post(url, object, requestHeaders(protectedRoute, true))
  */
}

export const auth = {
  register: (params) => http_requests.post(false, `${baseUrl}/v1/auth/register`, params),
  login: (params) => http_requests.post(false, `${baseUrl}/v1/auth/login`, params),
  logout: () => http_requests.delete(true, `${baseUrl}/v1/auth/logout`),
  verifyNewEmailAddress: (token) => http_requests.get(false, `${baseUrl}/v1/auth/verify?token=${token}`),  
  confirmEmailAddress: (token) => http_requests.get(false, `${baseUrl}/v1/auth/confirm?token=${token}`),  
  resendConfirmationEmail: (params) => http_requests.put(true, `${baseUrl}/v1/auth/confirm/resend`, params),
  confirmInvitation: (token) => http_requests.get(false, `${baseUrl}/v1/auth/activate?token=${token}`), 
  activateInvitation: (params) => http_requests.post(false, `${baseUrl}/v1/auth/activate`, params), 
  forgotPassword: (params) => http_requests.post(false, `${baseUrl}/v1/auth/forgot`, params),
  confirmResetToken: (token) => http_requests.get(false, `${baseUrl}/v1/auth/reset?token=${token}`),  
  verifyPromoCode: (code) => http_requests.get(false, `${baseUrl}/v1/auth/promo?code=${code}`),  
  resetPassword: (params) => http_requests.post(false, `${baseUrl}/v1/auth/reset`, params),
}

export const user = {
  details: () => http_requests.get(true, `${baseUrl}/v1/user`),
  accounts: () => http_requests.get(true, `${baseUrl}/v1/user/accounts`),
  profile: () => http_requests.get(true, `${baseUrl}/v1/user/settings/profile`),
  updateProfile: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/profile`, params),
  editEmail: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/security/email`, params),
  cancelEditEmail: () => http_requests.delete(true, `${baseUrl}/v1/user/settings/security/email`),
  editEmailResend: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/security/email/resend`, params),
  changePassword: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/security/password`, params),
  sessions: () => http_requests.delete(true, `${baseUrl}/v1/user/settings/security/sessions`),
}

export const account = {
  details: () => http_requests.get(true, `${baseUrl}/v1/account`),
 

  getBillingSubscription: () => http_requests.get(true, `${baseUrl}/v1/account/billing/subscription`),
  estimateSubscription: (params) => http_requests.put(true, `${baseUrl}/v1/account/billing/subscription/estimate`, params), 
  updateSubscription: (params) => http_requests.put(true, `${baseUrl}/v1/account/billing/subscription`, params), 
  getBillingContact: () => http_requests.get(true, `${baseUrl}/v1/account/billing/contact`),
  updateBillingContact: (params) => http_requests.put(true, `${baseUrl}/v1/account/billing/contact`, params),
  getBillingMethod: () => http_requests.get(true, `${baseUrl}/v1/account/billing/method`),
  updateBillingMethod: (params) => http_requests.put(true, `${baseUrl}/v1/account/billing/method`, params), 
  getBillingHistory: () => http_requests.get(true, `${baseUrl}/v1/account/billing/history`),

  onboardingProfile: (params) => http_requests.post(true, `${baseUrl}/v1/account/onboarding/profile`, params),
  onboardingLocation: (params) => http_requests.post(true, `${baseUrl}/v1/account/onboarding/location`, params),
  onboardingPlan: (params) => http_requests.post(true, `${baseUrl}/v1/account/onboarding/plan`, params),
  onboardingComplete: (params) => http_requests.post(true, `${baseUrl}/v1/account/onboarding/complete`, params),
  sendFeedback: (params) => http_requests.post(true, `${baseUrl}/v1/account/feedback`, params),

 

  profile: () => http_requests.get(true, `${baseUrl}/v1/account/settings/profile`),
  updateProfile: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/profile`, params),
  branding: () => http_requests.get(true, `${baseUrl}/v1/account/settings/branding`),
  updateBranding: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/branding`, params),
  regionalSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/regional`),
  updateRegionalSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/regional`, params),

  uploadDarkLogo: (file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/branding/dark-logo`, file),
  deleteDarkLogo: () => http_requests.delete(true, `${baseUrl}/v1/account/settings/branding/dark-logo`),
  uploadLightLogo: (file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/branding/light-logo`, file),
  deleteLightLogo: () => http_requests.delete(true, `${baseUrl}/v1/account/settings/branding/light-logo`),
  uploadFavicon: (file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/branding/favicon`, file),
  deleteFavicon: () => http_requests.delete(true, `${baseUrl}/v1/account/settings/branding/favicon`),


  addonsSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/addons`),
  updateAddOnsSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/addons`, params),

  displayConfigSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/displays/config`),
  updateDisplayConfigSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/displays/config`, params),


  displayDevices: () => http_requests.get(true, `${baseUrl}/v1/account/settings/displays/devices`),
  createDisplayDevice: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/displays/devices`, params),
  retrieveDisplayDevice: (id, params) => http_requests.get(true, `${baseUrl}/v1/account/settings/displays/devices/${id}`, params),
  updateDisplayDevice: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/displays/devices/${id}`, params),
  deleteDisplayDevice: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/displays/devices/${id}`),


  playlists: () => http_requests.get(true, `${baseUrl}/v1/account/settings/displays/playlists`),
  createPlaylist: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/displays/playlists`, params),
  retrievePlaylist: (id, params) => http_requests.get(true, `${baseUrl}/v1/account/settings/displays/playlists/${id}`, params),
  updatePlaylist: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/displays/playlists/${id}`, params),
  deletePlaylist: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/displays/playlists/${id}`), 


  listSlides: (playlist_id) => http_requests.get(true, `${baseUrl}/v1/account/settings/displays/playlists/${playlist_id}/slides`),
  createSlide: (playlist_id, file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/displays/playlists/${playlist_id}/slides`, file),
  retrieveSlide: (playlist_id, slide_id, params) => http_requests.get(true, `${baseUrl}/v1/account/settings/displays/playlists/${playlist_id}/slides/${slide_id}`, params),
  updateSlide: (playlist_id, slide_id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/displays/playlists/${playlist_id}/slides/${slide_id}`, params),
  deleteSlide: (playlist_id, slide_id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/displays/playlists/${playlist_id}/slides/${slide_id}`),

  

  languages: (queryString) => http_requests.get(true, `${baseUrl}/v1/account/settings/languages${queryString || ''}`),  
  supportedLanguages: (queryString) => http_requests.get(true, `${baseUrl}/v1/account/settings/languages/supported${queryString || ''}`),
  createLanguage: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/languages`, params),
  updateLanguage: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/languages/${id}`, params),
  deleteLanguage: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/languages/${id}`),



  notificationTypes: () => http_requests.get(true, `${baseUrl}/v1/account/settings/notifications/types`),
  createNotificationType: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/notifications/types`, params),
  updateNotificationType: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/notifications/types/${id}`, params),
  deleteNotificationType: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/notifications/types/${id}`),

  notificationTemplates: () => http_requests.get(true, `${baseUrl}/v1/account/settings/notifications/templates`),
  createNotificationTemplate: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/notifications/templates`, params),
  retrieveNotificationTemplate: (id) => http_requests.get(true, `${baseUrl}/v1/account/settings/notifications/templates/${id}`),
  updateNotificationTemplate: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/notifications/templates/${id}`, params), 
  deleteNotificationTemplate: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/notifications/templates/${id}`),
 
  contactTypes: (queryString) => http_requests.get(true, `${baseUrl}/v1/account/settings/contacts/types${queryString || ''}`),   

  createContactType: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/contacts/types`, params),
  updateContactType: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/contacts/types/${id}`, params),
  deleteContactType: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/contacts/types/${id}`),
 
  contactMethods: (queryString) => http_requests.get(true, `${baseUrl}/v1/account/settings/contacts/methods${queryString || ''}`), 
  createContactMethod: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/contacts/methods`, params),
  updateContactMethod: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/contacts/methods/${id}`, params),
  deleteContactMethod: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/contacts/methods/${id}`),


  phoneSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/phone`),
  phoneSubmitReview: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/phone/review`, params),
  phoneNumbers: () => http_requests.get(true, `${baseUrl}/v1/account/settings/phone/numbers`),

}

export const dashboards = {
  notificationsChart: () => http_requests.get(true, `${baseUrl}/v1/dashboards/overview/notifications-chart`),
  accountMetricsTable: () => http_requests.get(true, `${baseUrl}/v1/dashboards/overview/account-metrics-table`),
} 

export const reports = {
  getCurrentHeadcountReport: () => http_requests.get(true, `${baseUrl}/v1/reports/headcount/current`),  
  getHeadcountLogsReport: (queryString) => http_requests.get(true, `${baseUrl}/v1/reports/headcount/logs${queryString || ''}`),  
}

export const displays = {
  list: () => http_requests.get(true, `${baseUrl}/v1/displays`),
}

export const assets = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/resources/assets${queryString || ''}`),  
  createAsset: (params) => http_requests.post(true, `${baseUrl}/v1/resources/assets`, params),
  retrieveAsset: (id) => http_requests.get(true, `${baseUrl}/v1/resources/assets/${id}`),
  updateAsset: (id, params) => http_requests.put(true, `${baseUrl}/v1/resources/assets/${id}`, params),
  deleteAsset: (id) => http_requests.delete(true, `${baseUrl}/v1/resources/assets/${id}`),
  uploadAsset: (id, file) => http_requests.postFormData(true, `${baseUrl}/v1/resources/assets/${id}/upload`, file),
}

export const weblinks = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/resources/weblinks${queryString || ''}`),  
  createWeblink: (params) => http_requests.post(true, `${baseUrl}/v1/resources/weblinks`, params),
  retrieveWeblink: (id) => http_requests.get(true, `${baseUrl}/v1/resources/weblinks/${id}`),
  updateWeblink: (id, params) => http_requests.put(true, `${baseUrl}/v1/resources/weblinks/${id}`, params),
  deleteWeblink: (id) => http_requests.delete(true, `${baseUrl}/v1/resources/weblinks/${id}`),
}

export const documents = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/resources/documents${queryString || ''}`),  
  createDocument: (params) => http_requests.post(true, `${baseUrl}/v1/resources/documents`, params),
  retrieveDocument: (id) => http_requests.get(true, `${baseUrl}/v1/resources/documents/${id}`),
  updateDocument: (id, params) => http_requests.put(true, `${baseUrl}/v1/resources/documents/${id}`, params),
  deleteDocument: (id) => http_requests.delete(true, `${baseUrl}/v1/resources/documents/${id}`),
}

export const forms = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/resources/forms${queryString || ''}`),  
  createForm: (params) => http_requests.post(true, `${baseUrl}/v1/resources/forms`, params),
  retrieveForm: (id) => http_requests.get(true, `${baseUrl}/v1/resources/forms/${id}`),
  updateForm: (id, params) => http_requests.put(true, `${baseUrl}/v1/resources/forms/${id}`, params),
  deleteForm: (id) => http_requests.delete(true, `${baseUrl}/v1/resources/forms/${id}`),
}

export const campuses = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/campuses${queryString || ''}`), 
  createCampus: (params) => http_requests.post(true, `${baseUrl}/v1/campuses`, params),
  updateCampus: (id, params) => http_requests.put(true, `${baseUrl}/v1/campuses/${id}`, params),
  deleteCampus: (id) => http_requests.delete(true, `${baseUrl}/v1/campuses/${id}`),
}
export const locations = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/locations${queryString || ''}`),  
  createLocation: (params) => http_requests.post(true, `${baseUrl}/v1/locations`, params),
  retrieveLocation: (id) => http_requests.get(true, `${baseUrl}/v1/locations/${id}`),
  updateLocation: (id, params) => http_requests.put(true, `${baseUrl}/v1/locations/${id}`, params),
  deleteLocation: (id) => http_requests.delete(true, `${baseUrl}/v1/locations/${id}`),
}

export const floors = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/floors${queryString || ''}`),
  createFloor: (params) => http_requests.post(true, `${baseUrl}/v1/floors`, params),
  retrieveFloor: (id) => http_requests.get(true, `${baseUrl}/v1/floors/${id}`),
  updateFloor: (id, params) => http_requests.put(true, `${baseUrl}/v1/floors/${id}`, params),
  deleteFloor: (id) => http_requests.delete(true, `${baseUrl}/v1/floors/${id}`),
}

export const spaces = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/spaces${queryString || ''}`),
  options: () => http_requests.get(true, `${baseUrl}/v1/spaces/options`),
  createSpace: (params) => http_requests.post(true, `${baseUrl}/v1/spaces`, params),
  retrieveSpace: (id) => http_requests.get(true, `${baseUrl}/v1/spaces/${id}`),
  updateSpace: (id, params) => http_requests.put(true, `${baseUrl}/v1/spaces/${id}`, params),
  deleteSpace: (id) => http_requests.delete(true, `${baseUrl}/v1/spaces/${id}`),
}

export const notifications = {
  list: () => http_requests.get(true, `${baseUrl}/v1/notifications`),
  createNotification: (params) => http_requests.post(true, `${baseUrl}/v1/notifications`, params),
  retrieveNotification: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}`), 
  updateNotificationDraft: (id, params) => http_requests.put(true, `${baseUrl}/v1/notifications/${id}`, params),  
  deleteNotificationDraft: (id) => http_requests.delete(true, `${baseUrl}/v1/notifications/${id}`),


  clearNotification: (id, params) => http_requests.post(true, `${baseUrl}/v1/notifications/${id}/clear`, params),  

  sendNotification: (id) => http_requests.post(true, `${baseUrl}/v1/notifications/${id}/send`), 
  getNotificationRecipients: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/recipients`), 


  getNotificationChannels: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/channels`), 
  getNotificationContactTypes: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/contact-types`), 
  getNotificationResponses: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/responses`), 

  createTranslation: (params) => http_requests.post(true, `${baseUrl}/v1/notifications/translate`, params),
  calculateRecipients: (params) => http_requests.post(true, `${baseUrl}/v1/notifications/calculate-recipients`, params), 
  getNotes: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/notes`), 

  createNote: (id, params) => http_requests.post(true, `${baseUrl}/v1/notifications/${id}/notes`, params),   
  getTimeline: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/timeline`), 

  // CHARTS
  getNotificationRecipientsChart: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/charts/recipients`),
  getNotificationChannelsChart: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/charts/channels`),  
  getNotificationConfirmationChart: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/charts/confirmation`), 
  getNotificationRespondersChart: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/charts/responders`),   
  getNotificationDeliveryChart: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/charts/delivery`),  
  getNotificationRecipientTypesChart: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/charts/recipient-types`),   



  getUserDeliveryLogs: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/delivery-logs/users`), 
  getDeviceDeliveryLogs: (id) => http_requests.get(true, `${baseUrl}/v1/notifications/${id}/delivery-logs/devices`), 

}

export const contacts = {
  list: () => http_requests.get(true, `${baseUrl}/v1/contacts`),
  createContact: (params) => http_requests.post(true, `${baseUrl}/v1/contacts`, params), 
  createContactUser: (id, params) => http_requests.post(true, `${baseUrl}/v1/contacts/${id}/user`, params), 
  retrieveContact: (id) => http_requests.get(true, `${baseUrl}/v1/contacts/${id}`),
  deleteContact: (id) => http_requests.delete(true, `${baseUrl}/v1/contacts/${id}`),
}

export const users = {
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/users${queryString}`),
  createUser: (params) => http_requests.post(true, `${baseUrl}/v1/users`, params),  
  retrieveUser: (id) => http_requests.get(true, `${baseUrl}/v1/users/${id}`),
  updateUser: (id, params) => http_requests.put(true, `${baseUrl}/v1/users/${id}`, params),
  deleteUser: (id) => http_requests.delete(true, `${baseUrl}/v1/users/${id}`),
  resendUserInvite: (id) => http_requests.put(true, `${baseUrl}/v1/users/${id}/resend-invite`),
  getMobileSessions: (id) => http_requests.get(true, `${baseUrl}/v1/users/${id}/mobile-sessions`),
  sendTestNotification: (id, params) => http_requests.put(true, `${baseUrl}/v1/users/${id}/send-test`, params),
  sendTestPush: (id, params) => http_requests.put(true, `${baseUrl}/v1/users/${id}/send-push`, params),
}

export const groups = {  
  list: (queryString) => http_requests.get(true, `${baseUrl}/v1/groups${queryString || ''}`),  


  createGroup: (params) => http_requests.post(true, `${baseUrl}/v1/groups`, params),


  retrieveGroup: (id) => http_requests.get(true, `${baseUrl}/v1/groups/${id}`),
  retrieveGroupMembers: (id) => http_requests.get(true, `${baseUrl}/v1/groups/${id}/members`),
  updateGroup: (id, params) => http_requests.put(true, `${baseUrl}/v1/groups/${id}`, params),
  addUserToGroup: (id, params) => http_requests.post(true, `${baseUrl}/v1/groups/${id}/add`, params),
  removeUserFromGroup: (id, params) => http_requests.post(true, `${baseUrl}/v1/groups/${id}/remove`, params),
  deleteGroup: (id) => http_requests.delete(true, `${baseUrl}/v1/groups/${id}`),
}


///////////////////////////
// legacy
///////////////////////////
export const user1 = {

  forgotPassword: (params) => http_requests.post(false, `${baseUrl}/v1/user/forgot-password`, params),
  resetPassword: (params) => http_requests.post(false, `${baseUrl}/v1/user/reset-password`, params),
  confirmUser: (token) => http_requests.get(false, `${baseUrl}/v1/user/confirm?token=${token}`),
  resendConfirmationEmail: (params) => http_requests.put(true, `${baseUrl}/v1/user/confirm`, params),
  editEmail: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/security/email`, params),
  cancelEditEmail: () => http_requests.delete(true, `${baseUrl}/v1/user/settings/security/email`),
  editEmailResend: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/security/email/resend`, params),
  changePassword: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/security/password`, params),
  sessions: () => http_requests.delete(true, `${baseUrl}/v1/user/settings/security/sessions`),
  details: () => http_requests.get(true, `${baseUrl}/v1/user`),
  accounts: () => http_requests.get(true, `${baseUrl}/v1/user/accounts`),
  profile: () => http_requests.get(true, `${baseUrl}/v1/user/settings/profile`),
  notificationSettings: () => http_requests.get(true, `${baseUrl}/v1/user/settings/notifications`),
  updateNotificationSettings: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/notifications`, params),
  updateProfile: (params) => http_requests.put(true, `${baseUrl}/v1/user/settings/profile`, params),
  uploadProfileImage: (file) => http_requests.postFormData(true, `${baseUrl}/v1/user/settings/profile/image`, file),
  deleteProfileImage: () => http_requests.delete(true, `${baseUrl}/v1/user/settings/profile/image`),
}

export const account1 = {
  details: () => http_requests.get(true, `${baseUrl}/v1/account`),
  onboarding: (params) => http_requests.put(true, `${baseUrl}/v1/account/onboarding`, params),
 
  scheduleSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/schedule`),
  updateScheduleSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/schedule`, params),

  license: () => http_requests.get(true, `${baseUrl}/v1/account/settings/license-insurance`),
  updateLicenseSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/license-insurance`, params),
  uploadLicenseDocument: (file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/license-insurance/license-document`, file),
  deleteLicenseDocument: () => http_requests.delete(true, `${baseUrl}/v1/account/settings/license-insurance/license-document`),
  uploadInsuranceDocument: (file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/license-insurance/insurance-document`, file),
  deleteInsuranceDocument: () => http_requests.delete(true, `${baseUrl}/v1/account/settings/license-insurance/insurance-document`),

  requestSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/requests`),
  getRequestSetting: (id) => http_requests.get(true, `${baseUrl}/v1/account/settings/requests/${id}`),
  updateRequestSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/requests`, params),

  quoteSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/quotes`),
  updateQuoteSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/quotes`, params),

  invoiceSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/invoices`),
  updateInvoiceSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/invoices`, params),


  jobSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/jobs`),
  updateJobSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/jobs`, params),

  jobTypes: () => http_requests.get(true, `${baseUrl}/v1/account/settings/job-types`),
  createJobType: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/job-types`, params),
  updateJobType: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/job-types/${id}`, params),
  deleteJobType: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/job-types/${id}`),

  jobStatuses: () => http_requests.get(true, `${baseUrl}/v1/account/settings/job-statuses`),
  createJobStatus: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/job-statuses`, params),
  updateJobStatus: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/job-statuses/${id}`, params),
  deleteJobStatus: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/job-statuses/${id}`),


  roles: () => http_requests.get(true, `${baseUrl}/v1/account/settings/roles`),
  createRole: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/roles`, params),
  updateRole: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/roles/${id}`, params),

  employees: () => http_requests.get(true, `${baseUrl}/v1/account/settings/employees`),
  createEmployee: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/employees`, params),

  clientStatuses: () => http_requests.get(true, `${baseUrl}/v1/account/settings/client-statuses`),
  createClientStatus: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/client-statuses`, params),
  updateClientStatus: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/client-statuses/${id}`, params),
  deleteClientStatus: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/client-statuses/${id}`),

  leadSources: () => http_requests.get(true, `${baseUrl}/v1/account/settings/lead-sources`),
  createLeadSource: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/lead-sources`, params),
  updateLeadSource: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/lead-sources/${id}`, params),
  deleteLeadSource: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/lead-sources/${id}`),

  communicationSettings: () => http_requests.get(true, `${baseUrl}/v1/account/settings/communication`),
  updateCommunicationSettings: (params) => http_requests.put(true, `${baseUrl}/v1/account/settings/communication`, params),

  taxes: () => http_requests.get(true, `${baseUrl}/v1/account/settings/price-book/taxes`),
  createTax: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/price-book/taxes`, params),
  updateTax: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/price-book/taxes/${id}`, params),
  deleteTax: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/taxes/${id}`),

  services: () => http_requests.get(true, `${baseUrl}/v1/account/settings/price-book/services`),
  createService: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/price-book/services`, params),
  updateService: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/price-book/services/${id}`, params),
  deleteService: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/services/${id}`),
  uploadServiceImage: (id, file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/price-book/services/${id}/image`, file),
  deleteServiceImage: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/services/${id}/image`),

  materials: () => http_requests.get(true, `${baseUrl}/v1/account/settings/price-book/materials`),
  createMaterial: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/price-book/materials`, params),
  updateMaterial: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/price-book/materials/${id}`, params),
  deleteMaterial: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/materials/${id}`),
  uploadMaterialImage: (id, file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/price-book/materials/${id}/image`, file),
  deleteMaterialImage: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/materials/${id}/image`),

  equipment: () => http_requests.get(true, `${baseUrl}/v1/account/settings/price-book/equipment`),
  createEquipment: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/price-book/equipment`, params),
  updateEquipment: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/price-book/equipment/${id}`, params),
  deleteEquipment: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/equipment/${id}`),
  uploadEquipmentImage: (id, file) => http_requests.postFormData(true, `${baseUrl}/v1/account/settings/price-book/equipment/${id}/image`, file),
  deleteEquipmentImage: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/equipment/${id}/image`),

  discountsFees: () => http_requests.get(true, `${baseUrl}/v1/account/settings/price-book/discounts-fees`),
  getDiscounts: (type) => http_requests.get(true, `${baseUrl}/v1/account/settings/price-book/discounts-fees?item_type=${type}`),
  createDiscountFee: (params) => http_requests.post(true, `${baseUrl}/v1/account/settings/price-book/discounts-fees`, params),
  updateDiscountFee: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/price-book/discounts-fees/${id}`, params),
  deleteDiscountFee: (id) => http_requests.delete(true, `${baseUrl}/v1/account/settings/price-book/discounts-fees/${id}`),
}

export const accountBilling = {
  changePlan: (params) => http_requests.put(true, `${baseUrl}/v1/account/billing/subscription`, params),
}

export const employee = {
  details: (id) => http_requests.get(true, `${baseUrl}/v1/account/settings/employees/${id}`),
  updateEmployee: (id, params) => http_requests.put(true, `${baseUrl}/v1/account/settings/employees/${id}`, params),
}

export const clients = {
  statuses: () => http_requests.get(true, `${baseUrl}/v1/account/settings/client-statuses`),
  getStatus: (id) => http_requests.get(true, `${baseUrl}/v1/account/settings/client-statuses/${id}`),
  list: () => http_requests.get(true, `${baseUrl}/v1/clients`),
  createClient: (params) => http_requests.post(true, `${baseUrl}/v1/clients`, params),
  details: (id) => http_requests.get(true, `${baseUrl}/v1/clients/${id}`),
  updateClient: (id, params) => http_requests.put(true, `${baseUrl}/v1/clients/${id}`, params),
  updateContact: (id, params) => http_requests.put(true, `${baseUrl}/v1/contacts/${id}`, params),
  makePrimaryContact: (id, params) => http_requests.put(true, `${baseUrl}/v1/contacts/${id}/primary`, params),
  getContacts: (id) => http_requests.get(true, `${baseUrl}/v1/contacts?client_id=${id}`),
  createContacts: (params) => http_requests.post(true, `${baseUrl}/v1/contacts`, params),
  createAddresses: (params) => http_requests.post(true, `${baseUrl}/v1/addresses`, params),
  getAddress: (id) => http_requests.get(true, `${baseUrl}/v1/addresses?client_id=${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}/v1/clients${queryString}`),
  deleteClient: (id) => http_requests.delete(true, `${baseUrl}/v1/clients/${id}`),
  deleteContact: (id) => http_requests.delete(true, `${baseUrl}/v1/contacts/${id}`),
  archiveClient: (id) => http_requests.delete(true, `${baseUrl}/v1/clients/${id}/archive`),
  getRequests: (id) => http_requests.get(true, `${baseUrl}/v1/requests?client_id=${id}`),
  getQuotes: (id) => http_requests.get(true, `${baseUrl}/v1/quotes?client_id=${id}`),
}


export const addresses = {
  createAddress: (params) => http_requests.post(true, `${baseUrl}/v1/addresses`, params),
  updateAddress: (id, params) => http_requests.put(true, `${baseUrl}/v1/addresses/${id}`, params),
  deleteAddress: (id) => http_requests.delete(true, `${baseUrl}/v1/addresses/${id}`),
  archiveAddress: (id) => http_requests.delete(true, `${baseUrl}/v1/addresses/${id}/archive`),
  primaryAddress: (id) => http_requests.put(true, `${baseUrl}/v1/addresses/${id}/primary`),
  billingAddress: (id) => http_requests.put(true, `${baseUrl}/v1/addresses/${id}/billing`)
}

export const notes = {
  createNote: (params) => http_requests.post(true, `${baseUrl}/v1/notes`, params),
  listNotes: (queryString) => http_requests.get(true, `${baseUrl}/v1/notes${queryString}`),
  deleteNote: (id) => http_requests.delete(true, `${baseUrl}/v1/notes/${id}`),
}

export const attachments = {
  createAttachment: (formData) => http_requests.postFormDataPrepared(true, `${baseUrl}/v1/attachments`, formData),
  listAttachments: (queryString) => http_requests.get(true, `${baseUrl}/v1/attachments${queryString}`),
  updateAttachment: (id, params) => http_requests.put(true, `${baseUrl}/v1/attachments/${id}`, params),
  deleteAttachment: (id) => http_requests.delete(true, `${baseUrl}/v1/attachments/${id}`),
  deleteAttachment: (id) => http_requests.delete(true, `${baseUrl}/v1/attachments/${id}`),
  archiveAttachment: (id) => http_requests.delete(true, `${baseUrl}/v1/attachments/${id}/archive`),
}

export const quotes = {
  list: () => http_requests.get(true, `${baseUrl}/v1/quotes`),
  createQuote: (params) => http_requests.post(true, `${baseUrl}/v1/quotes`, params),
  details: (id) => http_requests.get(true, `${baseUrl}/v1/quotes/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}/v1/quotes${queryString}`),
}

export const requests = {
  list: () => http_requests.get(true, `${baseUrl}/v1/requests`),
  createQuote: (params) => http_requests.post(true, `${baseUrl}/v1/requests`, params),
  details: (id) => http_requests.get(true, `${baseUrl}/v1/requests/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}/v1/requests${queryString}`),
  createRequest: (formData) => http_requests.postFormDataPrepared(true, `${baseUrl}/v1/requests`, formData)
}

export const jobs = {
  list: () => http_requests.get(true, `${baseUrl}/v1/jobs`),
  createJob: (params) => http_requests.post(true, `${baseUrl}/v1/jobs`, params),
  details: (id) => http_requests.get(true, `${baseUrl}/v1/jobs/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}/v1/jobs${queryString}`),

  statuses: () => http_requests.get(true, `${baseUrl}/v1/account/settings/job-statuses`),
}

export const invoices = {
  list: () => http_requests.get(true, `${baseUrl}/v1/invoices`),
  createInvoice: (params) => http_requests.post(true, `${baseUrl}/v1/invoices`, params),
  details: (id) => http_requests.get(true, `${baseUrl}/v1/invoices/${id}`),
  search: (queryString) => http_requests.get(true, `${baseUrl}/v1/invoices${queryString}`),
}

export const timeline = {
  client: (id) => http_requests.get(true, `${baseUrl}/v1/timeline/clients/${id}`),
  request: (id) => http_requests.get(true, `${baseUrl}/v1/timeline/requests/${id}`),
}